/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { OrdersHourlyReportDatum } from "@lemmonhq/types";
import { formatPriceInLocale } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

export const HourlySales = defineComponent<{
  data: OrdersHourlyReportDatum[];
  currency: string;
}>({
  name: "HourlySales",
  props: ["data", "currency"],
  setup(props) {
    const showRevenue = ref(true);
    const { t } = useLocalization();
    return () => {
      const maxValue = Math.max(
        ...props.data.map((d) =>
          showRevenue.value ? d.total_revenue : d.total_count,
        ),
      );

      return (
        <div class="card transition-shadow border rounded-lg md:rounded-box lg:col-span-2">
          <div class="card-body p-4 md:p-6">
            <div class="flex justify-between items-center">
              <h3 class="card-title flex items-center gap-2 text-accent font-normal">
                <span class="material-symbols-outlined">schedule</span>
                {t("reports.dashboard.hourly_sales")}
              </h3>
              <div class="join">
                <button
                  class={`join-item btn btn-sm ${
                    showRevenue.value ? "btn-active" : ""
                  }`}
                  onClick={() => (showRevenue.value = true)}
                >
                  <span class="material-symbols-outlined sm:hidden text-base">
                    payments
                  </span>
                  <span class="hidden sm:inline">
                    {t("reports.dashboard.revenue")}
                  </span>
                </button>
                <button
                  class={`join-item btn btn-sm ${
                    !showRevenue.value ? "btn-active" : ""
                  }`}
                  onClick={() => (showRevenue.value = false)}
                >
                  <span class="material-symbols-outlined sm:hidden text-base">
                    tag
                  </span>
                  <span class="hidden sm:inline">
                    {t("reports.dashboard.count")}
                  </span>
                </button>
              </div>
            </div>
            <div class="space-y-2 md:space-y-3 pt-4 md:pt-6">
              {props.data
                .filter((el) => el.total_count > 0)
                .map((hour) => {
                  const value = showRevenue.value
                    ? hour.total_revenue
                    : hour.total_count;
                  const percentage = (value / maxValue) * 100;
                  return (
                    <div key={hour.sale_hour} class="group">
                      <div class="flex justify-between mb-1">
                        <span class="text-sm text-accent">
                          {(hour.sale_hour || "").toString().padStart(2, "0")}
                          :00
                        </span>
                        <span class="text-sm">
                          {showRevenue.value
                            ? formatPriceInLocale(
                                hour.total_revenue,
                                true,
                                0,
                                props.currency,
                              )
                            : hour.total_count}
                        </span>
                      </div>
                      <div class="w-full h-2 bg-base-300 rounded-full overflow-hidden">
                        <div
                          class="h-full bg-primary transition-all group-hover:brightness-110"
                          style={{ width: `${percentage}%` }}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      );
    };
  },
});
